"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sync = exports.Async = void 0;
var async_1 = require("./async");
Object.defineProperty(exports, "Async", { enumerable: true, get: function () { return async_1.Async; } });
var sync_1 = require("./sync");
Object.defineProperty(exports, "Sync", { enumerable: true, get: function () { return sync_1.Sync; } });
